import ArrowUpRightIcon from '@elementor/icons/ArrowUpRightIcon';
import Button from '@elementor/ui/Button';
import { styled } from '@elementor/ui/styles';
import PropTypes from 'prop-types';
import { useInstallModalContext } from '@context/install-modal-context';
import { __ } from '@utils/i18n';

const GetFreeButton = ({ href = '', ...props }) => {
	const { open } = useInstallModalContext();
	const clickHandler =
		typeof props.onClick === 'function' ? props.onClick : null;

	if (clickHandler) {
		delete props.onClick;
	}

	const onClick = () => {
		open();

		if (clickHandler) {
			clickHandler();
		}
	};

	return (
		<StyledActionButton
			size="small"
			color="neutral"
			variant="contained"
			onClick={onClick}
			endIcon={<ArrowUpRightIcon />}
			target="_blank"
			{...props}
		>
			{__('Get it free')}
		</StyledActionButton>
	);
};

const StyledActionButton = styled(Button)`
	border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;

	background: #aa2681;
	color: ${({ theme }) => theme.palette.secondary.contrastText};
	line-height: 22px;
	letter-spacing: 0.46px;
	transition: 300ms ease-in-out;

	&:hover,
	&:focus-visible,
	&:active {
		background: #871865;
		color: ${({ theme }) => theme.palette.secondary.contrastText};
		transition: 300ms ease-in-out;
	}
`;

GetFreeButton.propTypes = {
	href: PropTypes.string,
	onClick: PropTypes.func,
};

export default GetFreeButton;
